import React from 'react';
import { Helmet } from "react-helmet";
import { Music } from "../sections/Music/Music";

const MusicPage = () => {
    return (
        <>
            <Helmet>
                <title>Lembawe9 - Music</title>
                <meta 
                    name="description" 
                    content="Official website of Lembawe9, the influential Moroccan street rap artist. Listen, shop, and connect." 
                />
            </Helmet>
            <main>
                <Music/>
            </main>
        </>
    )
}

export default MusicPage
